const regNumberRegex = new RegExp('^[a-zA-Z]{2}\\d{5}$', 'g');

export const regNumber = (value) => {
    value = value.replace(/\s/g, '');

    if (!regNumberRegex.test(value)) {
        return null;
    }

    return value;
};
